import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './navbar.css';
import logo from '../assets/img/AccessEVA.jpg';
import logo_ent from '../assets/img/AccessEVAEnterprise.jpg';
import { getConfig } from './../api';

function MainNavbar() {
  const [enterpriseOrg, setEnterpriseOrg] = useState("");

  useEffect(() => {
    checkEnterprise();
  }, []);

  const checkEnterprise = async () => {
    const response = await getConfig();
    const data = response.data;
    //console.log("config:", data);
    setEnterpriseOrg(data.enterpriseOrg);
  };
  const items = [
    /*  { path: '/', title: 'Home' }, */
    { path: '/signup', title: 'Sign Up' },
    { path: '/login', title: 'Login' },
    /*  { path: '/adminlogin', title: 'Admin Login' },  */
    /*  { path: '/logout', title: 'Logout' }, */

  ];

  return (
    <div className="sticky-top" >
      {enterpriseOrg !== "" && (
        <>
          <nav className="navbar navbar-expand-md bg-body-secondary py-0 px-2">
            <div className="container-fluid">
              <a className="navbar-brand fs-6 fw-bold text-muted" href="#">{enterpriseOrg}</a>
            </div>
          </nav>
        </>
      )}

      <nav className="navbar navbar-expand-lg navbar-light bg-white sticky-top ps-0 py-0 my-0 border-bottom" aria-label="">
        <div className="container-fluid ps-2 py-0 my-0">
          <a className="navbar-brand fw-bold p-0 my-0" href="/">
            {enterpriseOrg ? (
              <img
                src={logo_ent}
                alt=""
                style={{ height: '46px' }}
                className="img-fluid px-0 my-0"
              />
            ) : (
              <img
                src={logo}
                alt=""
                style={{ width: '8em' }}
                className="mb-2"
              />
            )}
          </a>
          <button className="navbar-toggler collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarMenu"
            aria-controls="navbarMenu"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>
          <div className="collapse navbar-collapse" id="navbarMenu">
            <ul className="navbar-nav ms-auto mb-2 mb-md-0 small">
              {
                items.map((item, i) => (
                  <li key={i} className="nav-item">
                    <NavLink className="btn btn-outline-secondary btn-sm mt-1 ms-2" to={item.path}>{item.title}</NavLink>
                  </li>
                ))
              }
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default MainNavbar;
